<div *ngIf="config">
  <ck-editor #ckEditor="ckEditor" [(ngModel)]="value" (change)="onChange($event)" [config]="config" (ready)="ckeditorReady($event)"></ck-editor>
</div>
